// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"03e59b5f","184":"163f5d67","426":"9263c51a","936":"91ce7a06"}[chunkId] + ".chunk.js";
};